import { compose, mdsWidget } from 'dojo/_base/declare';

import FinderBaseV2 from '../../FinderBase/FinderBaseV2';
import lang from 'dojo/_base/lang';
import TemplateEditor from './TemplateEditor';
import { Template } from "../ScreenplayTypes";

class TemplateFinder extends compose(FinderBaseV2) {

    private _onRowClick(row: StaticTable.StaticTableRow<Template>): void {
        let editor = new TemplateEditor();
        this._addEditorEventListener(editor);
        let entity = row.rowGroup.entity;
        editor.setup(this.getTabContainer(), entity);
    }

    private _onClickNew(e: MouseEvent): void {
        let editor = new TemplateEditor();
        this._addEditorEventListener(editor);
        editor.setup(this.getTabContainer());
    }

    private _tableFormatter(cell: StaticTable.StaticTableCell<Template>): boolean {
        let name = cell.name;
        let entity = cell.entity;
        let node = cell.tableCellNode;
        let value = cell.value;

        switch (name) {

        }

        return false;
    }

    private _addEditorEventListener(editor: MdsLax<InstanceType<typeof TemplateEditor>>): void {
        editor.on("changed", lang.hitch(this, this.reload));
        editor.on("deleted", lang.hitch(this, this.reload));
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.setupFinderWithCallfunctions(
            "Webtool_API_Screenplay__Template_GetFinderConfig",
            "Webtool_API_Screenplay__Template_GetFinderResults",
            lang.hitch(this, this._onRowClick),
            lang.hitch(this, this._tableFormatter),
            { neededUserRole: "Screenplay_Template", callback: lang.hitch(this, this._onClickNew) });
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TemplateFinder);